export const openMiniBasket = (event) => {
  if (window.isMinibasketLoaded) {
    event.preventDefault();
    window.dispatchEvent(
      new CustomEvent('jl-events.browser.showMinibasket', {
        detail: {
          source: 'page',
        },
      })
    );
  }
};
